// Whether this window is in front and being looked at: what decides that a
// chat counts as read and that a notice needs no OS notification.
//
// Promise: in the desktop app it is the app's word (`isActive`: closing only
// hides the window, and the page stays "visible"); in a browser the page must
// be visible and focused. `useWindowInFront` re-renders when that changes.
import { useSyncExternalStore } from "react";
import { desktopShell } from "./desktop-shell";

export function isWindowInFront(): boolean {
  const active = desktopShell()?.isActive?.();
  if (active !== undefined) return active;
  if (typeof document === "undefined") return false;
  return document.visibilityState === "visible" && document.hasFocus();
}

export function subscribeWindowFront(onChange: () => void): () => void {
  window.addEventListener("focus", onChange);
  window.addEventListener("blur", onChange);
  document.addEventListener("visibilitychange", onChange);
  const offDesktop = desktopShell()?.onActiveChange?.(() => onChange());
  return () => {
    window.removeEventListener("focus", onChange);
    window.removeEventListener("blur", onChange);
    document.removeEventListener("visibilitychange", onChange);
    offDesktop?.();
  };
}

export function useWindowInFront(): boolean {
  return useSyncExternalStore(
    subscribeWindowFront,
    isWindowInFront,
    () => false,
  );
}
